export const PARAMS_KEYS_FOR_TESTING_NODE = ['to'];

export const VerificationEmailTypes = {
	REPLY_TO: 'reply_to',
	UNSUBSCRIBE_CONTACT: 'unsubscribe_contact',
};
